exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._16-rOz8Igrx4ThxREkyZUJ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100vh;\n}\n", ""]);

// exports
exports.locals = {
	"loadingPage": "_16-rOz8Igrx4ThxREkyZUJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"importLoaders":1}!./~/postcss-loader/lib?{"config":{"path":"/workspace/config/postcss.config.js"}}!./src/components/loading-page/index-module.css
// module id = 2545
// module chunks = 3 14